'use client';

import { useEffect, type ComponentPropsWithoutRef } from 'react';

type DetailsAnchorLinkProps = Omit<ComponentPropsWithoutRef<'a'>, 'href'> & {
  targetId: string;
};

function openTargetDetails(targetId: string) {
  const target = document.getElementById(targetId);

  if (target instanceof HTMLDetailsElement) {
    target.open = true;
  }
}

export default function DetailsAnchorLink({
  targetId,
  onClick,
  ...props
}: DetailsAnchorLinkProps) {
  useEffect(() => {
    const openDetailsForCurrentHash = () => {
      if (window.location.hash === `#${targetId}`) {
        openTargetDetails(targetId);
      }
    };

    openDetailsForCurrentHash();
    window.addEventListener('hashchange', openDetailsForCurrentHash);

    return () => window.removeEventListener('hashchange', openDetailsForCurrentHash);
  }, [targetId]);

  return (
    <a
      {...props}
      href={`#${targetId}`}
      onClick={(event) => {
        openTargetDetails(targetId);
        onClick?.(event);
      }}
    />
  );
}
